import { API } from 'aws-amplify';

// const saveMission = `
//   mutation SaveMission($mission: AWSJSON!, $doFeedBlast: Boolean) {
//     saveMission(mission: $mission, doFeedBlast: $doFeedBlast)
//   }
// `;

// NOTE: The saveGame mutation currently does not have the newBrackets boolean
// const saveGameQuery = `
//   mutation SaveGame($mission: AWSJSON!, $doFeedBlast: Boolean, $newBrackets: Boolean) {
//     saveGame(mission: $mission, doFeedBlast: $doFeedBlast, newBrackets: $newBrackets)
//   }
// `;
const saveGameQuery = `
  mutation SaveGame($mission: AWSJSON!, $doFeedBlast: Boolean) {
    saveGame(mission: $mission, doFeedBlast: $doFeedBlast)
  }
`;

const saveGame = async (values: any) => {
  try {
    // const saveMissionRes = await API.graphql({
    //   query: saveMission,
    //   variables: {
    //     mission: JSON.stringify(values),
    //     doFeedBlast: true,
    //   },
    // });

    const saveGameRes = await API.graphql({
      query: saveGameQuery,
      variables: {
        mission: JSON.stringify(values),
        doFeedBlast: true,
        // newBrackets: true,
      },
    });

    console.log('saveGame saveGameRes raw:', saveGameRes);

    // @ts-ignore - First try to parse the response as JSON
    const responseData = saveGameRes.data.saveGame;

    // Check if the response is a JSON string that needs parsing
    let parsedGame;
    if (typeof responseData === 'string') {
      try {
        parsedGame = JSON.parse(responseData);
        console.log('Parsed game data from string:', parsedGame);
        return parsedGame;
      } catch (e) {
        console.log('Response is not a valid JSON string, returning as is');
        return responseData;
      }
    }

    console.log('Returning direct response:', responseData);
    return responseData;
    // return saveMissionRes.data.saveMission;
  } catch (error) {
    console.error('Error in saveGame:', error);
    throw error;
  }
};

export default saveGame;
